import React, { useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

export default function SEO() {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    const inferBackend = () => {
      try {
        const { protocol, hostname } = window.location;
        const parts = hostname.split('.');
        if (parts.length >= 2) {
          const domain = parts.slice(1).join('.');
          return `${protocol}//backend.${domain}`;
        }
      } catch {}
      return '';
    };
    (async () => {
      try {
        const base = inferBackend();
        if (!base) return;
        const r = await fetch(`${base}/api/platform-data`);
        const j = await r.json().catch(()=>({}));
        if (r.ok && j && j.data) {
          const d = j.data;
          const url = window.location.href;
          const title = d.brandName ? `${d.brandName} Admin` : 'Admin';
          const desc = d.brandAddress || d.contactEmail || d.domain || 'Admin panel';
          const image = d.logoBase64 || undefined;
          setMeta({ title, desc, url, image, brand: d.brandName || '' });
        }
      } catch {}
    })();
  }, []);

  if (!meta) return null;
  const ld = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: meta.brand,
    url: window.location.origin,
    logo: meta.image,
    contactPoint: [{ '@type': 'ContactPoint', email: meta.desc }],
  };

  return (
    <HelmetProvider>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.desc} />

        {/* Open Graph */}
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.desc} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={meta.url} />
        {meta.image && <meta property="og:image" content={meta.image} />}

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.desc} />
        {meta.image && <meta name="twitter:image" content={meta.image} />}

        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify(ld)}</script>
      </Helmet>
    </HelmetProvider>
  );
}

